/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import $ from 'jquery';
import dayjs from 'dayjs';
import debounce from 'lodash.debounce';
import { useSelector } from 'react-redux';
import { components } from 'react-select';
import { useHistory } from 'react-router-dom';
import { func, string, bool, objectOf } from 'prop-types';

import DSPInvoiceFilters from './InvoiceFilters';
import Theme from '../../../../theme/Theme';
import DSPInvoiceTabs from './InvoiceTabs';
import TableMobileView from '../../../../common/TableMobileView';
import ShowCurrencySymbol from '../../../../common/ShowCurrencySymbol';
import { CompanyDefaultUser } from '../../../../theme/images';
import { getFinanceInvoices } from '../../../../api';
import { DropDown } from '../../../Customer/CustomerDetailView/CompanyPerformance/DropDown';
import {
  InvoicesStatusOptions,
  InvoicesSortByOptions,
  StatusColorSet,
  PATH_CUSTOMER_DETAILS,
  getInvoiceStatusKey,
  invoiceStatusIcons,
  channelInvoiceTypeOptions,
  invoiceTableHeaders,
} from '../../../../constants';
import {
  WhiteCard,
  Table,
  Status,
  DropdownIndicator,
  PageLoader,
  CommonPagination,
  NoData,
  SingleSelectDropdown,
} from '../../../../common';

export default function InvoicesList({
  timeFrame,
  timeFrameType,
  isTimeFrameChange,
  setIsTimeFrameChange,
  onTabClick,
  viewComponent,
  isDesktop,
  isTablet,
  selectedNavigation,
}) {
  const mounted = useRef(false);
  const history = useHistory();
  const isBBEInternalUser = useSelector(
    (state) => state.userState.userInfo.isInternalUser,
  );
  const isBBEInternalUserStatus = isBBEInternalUser ? 'internal' : 'external';

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('any');
  const [invoiceLoader, setInvoiceLoader] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  const [invoiceCount, setInvoiceCount] = useState(null);
  const [pageNumber, setPageNumber] = useState();
  const { Option, SingleValue } = components;
  const [responseId, setResponseId] = useState(null);

  const showChannelFilter = useMemo(() => {
    return ['retainer', 'rev share', 'upsell'].includes(selectedNavigation);
  }, [selectedNavigation]);

  const channelInvoiceTypes = useMemo(() => {
    return selectedNavigation === 'retainer'
      ? channelInvoiceTypeOptions?.monthlyRetainer
      : selectedNavigation === 'rev share'
      ? channelInvoiceTypeOptions?.revShare
      : selectedNavigation === 'upsell'
      ? channelInvoiceTypeOptions?.upsell
      : [];
  }, [selectedNavigation]);

  const [selectedChannelType, setSelectedChannelType] = useState(
    channelInvoiceTypes?.[0],
  );

  const [selectedSortBy, setSelectedSortBy] = useState({
    value: '',
    label: 'Status',
  });

  const getInvoices = useCallback(
    (searchKey, status, sortBy, page, channelType) => {
      setInvoiceLoader(true);

      getFinanceInvoices(
        'invoice',
        searchKey,
        status,
        sortBy,
        timeFrameType,
        timeFrame,
        page,
        selectedNavigation,
        channelType,
      ).then((res) => {
        if (mounted.current) {
          if (res?.status === 200 && res?.data?.results) {
            setInvoiceData(res.data.results);
            setInvoiceCount(res.data.count);
          } else {
            setInvoiceData([]);
            setInvoiceCount(0);
          }
          setInvoiceLoader(false);
        }
      });
    },
    [timeFrameType, timeFrame, selectedNavigation],
  );

  useEffect(() => {
    mounted.current = true;
    if (responseId === null || isTimeFrameChange) {
      getInvoices(
        searchQuery,
        selectedStatus,
        selectedSortBy.value,
        1,
        selectedChannelType?.value,
      );
      setResponseId('12345');
      setIsTimeFrameChange(false);
    }
    return () => {
      mounted.current = false;
    };
  }, [
    getInvoices,
    searchQuery,
    selectedStatus,
    selectedSortBy,
    responseId,
    setIsTimeFrameChange,
    isTimeFrameChange,
    selectedChannelType,
  ]);

  const debouncedSave = useCallback(
    debounce(
      (searchKey, status, sortBy, page) =>
        getInvoices(
          searchKey,
          status,
          sortBy,
          page,
          selectedChannelType?.value,
        ),
      500,
    ),
    [selectedChannelType],
  );

  const onHandleSearch = (event) => {
    setSearchQuery(event.target.value);
    debouncedSave(event.target.value, selectedStatus, selectedSortBy.value, 1);
  };

  const handleResetFilter = () => {
    $('.checkboxes input:radio').filter("[value='any']").prop('checked', true);
    setSelectedStatus('any');
    setSearchQuery('');
    setSelectedSortBy({ value: '', label: 'Status' });
    setSelectedChannelType(channelInvoiceTypes?.[0]);
    setPageNumber(1);
    getInvoices('', 'any', '', 1, channelInvoiceTypes?.[0]?.value);
  };

  const callToInvoicesApi = ({
    search = searchQuery,
    status = selectedStatus,
    sortBy = selectedSortBy?.value,
    page = 1,
    channelType = selectedChannelType?.value,
  } = {}) => {
    setPageNumber(page);
    getInvoices(search, status, sortBy, page, channelType);
  };

  const handleStatusChange = ({ target: { value } }) => {
    setSelectedStatus(value);
    callToInvoicesApi({ status: value });
  };

  const handleSortByFilter = (event) => {
    setSelectedSortBy(event);
    callToInvoicesApi({ sortBy: event.value });
  };

  const handlePageChange = (currentPage) => {
    callToInvoicesApi({ page: currentPage });
  };

  const handleChannelTypeChange = (event) => {
    setSelectedChannelType(event);
    callToInvoicesApi({ channelType: event?.value });
  };

  const displayLoader = () => {
    return (
      <PageLoader
        component="performance-graph"
        color={Theme.orange}
        type="detail"
        width={40}
        height={40}
      />
    );
  };

  const displayPagination = () => {
    return (
      <CommonPagination
        count={invoiceCount}
        pageNumber={pageNumber}
        handlePageChange={handlePageChange}
      />
    );
  };

  const filterOption = ({ data, ...props }) => (
    <Option {...props}>
      <div className="pb-2">
        <span style={{ fontSize: '15px', color: '#000000' }}>{data.label}</span>

        <div style={{ fontSize: '12px', color: '#556178' }}>{data.sub}</div>
      </div>
    </Option>
  );

  const bindAmount = (orignalNumber, decimalDigits = 2, isRounded = false) => {
    let number = Number(orignalNumber);
    if (number !== undefined && number !== null) {
      number = number
        .toFixed(decimalDigits)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    if (isRounded) {
      const no = number.toString().split('.');
      if (no[1] === '00') {
        return no[0];
      }
    }

    return number;
  };

  const singleFilterOption = (props) => (
    <SingleValue {...props}>
      <span style={{ fontSize: '15px', color: '#000000' }}>
        {`Sort by: ${props.data.label}`}
      </span>
      <div style={{ fontSize: '12px', color: '#556178' }}>{props.data.sub}</div>
    </SingleValue>
  );

  const getSelectComponents = () => {
    return {
      Option: filterOption,
      SingleValue: singleFilterOption,
      DropdownIndicator,
    };
  };

  const renderSortByDropDown = () => {
    return DropDown(
      'BT-InvoiceListSortOptionFilter',
      '',
      InvoicesSortByOptions,
      InvoicesSortByOptions &&
        InvoicesSortByOptions[0] &&
        InvoicesSortByOptions[0].label,
      getSelectComponents,
      handleSortByFilter,
      false,
      null,
      selectedSortBy,
    );
  };

  const getSingleSelectComponents = () => {
    return {
      DropdownIndicator,
    };
  };

  const displaySingleSelectDropdownfilter = (
    filterId,
    dropdownOptions,
    selectedValue,
    onChangeHandler,
    dropdownComponents,
    isApiCall,
  ) => {
    return (
      <SingleSelectDropdown
        filterId={filterId}
        dropdownOptions={dropdownOptions}
        selectedValue={selectedValue}
        onChangeHandler={onChangeHandler}
        dropdownComponents={dropdownComponents}
        isApiCall={isApiCall}
        isSearchable={false}
      />
    );
  };

  const displayInvoicesHeader = () => {
    return (
      <div className="row align-items-center">
        <div className="col-3 col-md-4 col-xl-6 pr-0">
          <div className="black-heading-title">Invoices</div>
        </div>
        <div className="col-9 col-md-8 col-xl-6">
          <div className="row justify-content-end">
            {showChannelFilter && (
              <div className="col-7 col-xl-6 pr-0">
                {displaySingleSelectDropdownfilter(
                  'BT-financeChannelTypeFilter',
                  channelInvoiceTypes,
                  selectedChannelType,
                  handleChannelTypeChange,
                  getSingleSelectComponents,
                  invoiceLoader,
                )}
              </div>
            )}
            <div className="col-5 col-xl-6">
              <div id="BT-finace-dah-invoice-dropdown">
                {renderSortByDropDown()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderTableData = (item) => {
    const cretaedDate = dayjs(item.generated_at).format('MM/DD/YY');
    const dueDate = dayjs(item.due_date).format('MM/DD/YY');
    return (
      <tr
        className="cursor"
        key={item.next_invoiced_id}
        onClick={() =>
          history.push(
            `${PATH_CUSTOMER_DETAILS.replace(
              ':id',
              item?.customer?.id,
            )}?tab=billing&nav=${selectedNavigation}&access=${isBBEInternalUserStatus}`,
            selectedNavigation,
          )
        }
      >
        <td className="product-body">
          <img
            className="company-logo"
            src={
              item && item.customer && item.customer.profile_picture
                ? item.customer.profile_picture
                : CompanyDefaultUser
            }
            alt="logo"
          />
          <div className="company-info-details">
            <div className="company-name">
              {item.customer && item.customer.name}
            </div>
            <div className="status">
              {item.invoice_type} | #{item.next_invoiced_id}
            </div>
          </div>
        </td>
        <td className="product-table-body">
          {ShowCurrencySymbol(item?.local_currency)}
          {bindAmount(item.monthly_budget, 0, true)}
        </td>
        <td className="product-table-body light-font">{cretaedDate}</td>
        <td className="product-table-body light-font">{dueDate}</td>
        <td className="product-table-body">
          <Status
            // className="float-right"
            label={item?.invoice_status.replace(' )', ')')}
            backgroundColor={
              StatusColorSet[getInvoiceStatusKey(item?.invoice_status)]
            }
            iconAfterLabel
            fontIcon={
              invoiceStatusIcons[getInvoiceStatusKey(item?.invoice_status)]
                ?.icon
            }
            labelColor={
              invoiceStatusIcons[getInvoiceStatusKey(item?.invoice_status)]
                ?.iconColor
            }
          />
          <div className="clear-fix" />
        </td>
      </tr>
    );
  };

  const renderInvoicesTable = () => {
    return (
      <Table>
        <thead>
          <tr>
            {invoiceTableHeaders.map(({ label, key, width }) => (
              <th key={key} width={width} className="product-header">
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {invoiceData && invoiceData.map((item) => renderTableData(item))}
        </tbody>
      </Table>
    );
  };

  const renderTabletInvoicesTable = () => {
    return (
      <>
        {invoiceData && invoiceData.length > 0 ? (
          invoiceData &&
          invoiceData.map((item) => (
            <TableMobileView
              onClick={() =>
                history.push(
                  PATH_CUSTOMER_DETAILS.replace(
                    ':id',
                    item.customer && item.customer.id,
                  ),
                  selectedNavigation,
                )
              }
              key={item.next_invoiced_id}
              className="mb-3 cursor"
              CompanyName={item.customer && item.customer.name}
              invoiceType={item.invoice_type}
              invoiceId={`#${item?.next_invoiced_id}`}
              label="AMOUNT"
              labelInfo={`${ShowCurrencySymbol(
                item?.local_currency,
              )}${bindAmount(item.monthly_budget, 0, true)}`}
              label1="CREATED ON"
              labelInfo1={dayjs(item.generated_at).format('MM/DD/YY')}
              label2="DUE"
              labelInfo2={dayjs(item.due_date).format('MM/DD/YY')}
              status={item?.invoice_status.replace(' )', ')')}
              statusIcon={
                invoiceStatusIcons[getInvoiceStatusKey(item?.invoice_status)]
                  ?.icon
              }
              statusColor={
                StatusColorSet[getInvoiceStatusKey(item?.invoice_status)]
              }
              iconAfterLabel
            />
          ))
        ) : (
          <NoData>No Invoices Found</NoData>
        )}
      </>
    );
  };

  return (
    <>
      <div className="col-xl-2 col-lg-3 col-md-12">
        {isDesktop ? (
          <DSPInvoiceTabs
            onTabClick={onTabClick}
            viewComponent={viewComponent}
          />
        ) : null}
        <DSPInvoiceFilters
          searchQuery={searchQuery}
          selectedStatus={selectedStatus}
          statusOptions={InvoicesStatusOptions}
          onHandleSearch={onHandleSearch}
          handleResetFilter={handleResetFilter}
          handleStatusChange={handleStatusChange}
        />
      </div>
      <div className="col-xl-10 col-lg-9 col-md-12">
        {isDesktop || isTablet ? (
          <WhiteCard className="d-lg-block d-md-block d-none">
            {displayInvoicesHeader()}
            <div className="straight-line horizontal-line mt-3" />
            {invoiceLoader ? (
              displayLoader()
            ) : invoiceData && invoiceData.length > 0 ? (
              <div className="mt-1">
                {renderInvoicesTable()}
                <div className="straight-line horizontal-line mt-3" />
                {displayPagination()}
              </div>
            ) : (
              <NoData>No Invoices Found</NoData>
            )}
          </WhiteCard>
        ) : (
          <div className="d-md-none mt-3">
            {displayInvoicesHeader()}
            {invoiceLoader ? (
              displayLoader()
            ) : invoiceData && invoiceData.length > 0 ? (
              <div className="mt-3">
                {renderTabletInvoicesTable()}
                {displayPagination()}
              </div>
            ) : (
              <NoData>No Invoices Found</NoData>
            )}
          </div>
        )}
      </div>
    </>
  );
}

InvoicesList.defaultProps = {
  data: () => {},
  onTabClick: () => {},
  timeFrame: new Date(),
  timeFrameType: '',
  isTimeFrameChange: false,
  setIsTimeFrameChange: () => {},
  selectedNavigation: '',
};
InvoicesList.propTypes = {
  data: func,
  onTabClick: func,
  viewComponent: string.isRequired,
  isDesktop: bool.isRequired,
  isTablet: bool.isRequired,
  timeFrame: objectOf(Object),
  timeFrameType: string,
  isTimeFrameChange: bool,
  setIsTimeFrameChange: func,
  selectedNavigation: string,
};
